import React from 'react';
import styled from 'styled-components';
import { TfiPlus } from 'react-icons/tfi';

const Card = styled.div`
  background: #ffffff;
  overflow: hidden;
  cursor: ${props => (props.clickable ? 'pointer' : 'default')};
  box-shadow: 0 8px 32px rgba(59, 131, 246, 0.11);
  transition: transform 0.3s ease;

  &:hover {
    transform: ${props => (props.clickable ? 'translateY(-3px)' : 'none')};
    box-shadow: 0 12px 40px rgba(59, 130, 246, 0.12);
  }
`;

const ImageWrap = styled.div`
  width: 100%;
  height: 350px;
  background: #f8fafc;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease;
  }

  &:hover img { transform: scale(1.05); }
  &:hover div.overlay { opacity: 1; }
`;

const Overlay = styled.div`
  position: absolute;
  inset: 0;
  background: rgba(0,0,0,0.4);
  opacity: 0;
  transition: opacity 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;

  &.overlay { opacity: 0; }
`;

const Title = styled.h3`
  color: #fff;
  font-size: 1.1rem;
  font-weight: 600;
  text-align: center;
  padding: 0 1rem;
  line-height: 1.4;
  white-space: pre-line;
`;

const ExternalIcon = styled(TfiPlus)`
  position: absolute;
  top: 10px;
  right: 10px;
  color: white;
  font-size: 40px;
  z-index: 3;
`;

function ProductCard({ product, onClick }) {
  const clickable = !!product.detailPath;

  return (
    <Card clickable={clickable} onClick={() => clickable && onClick?.(product)}>
      <ImageWrap>
        <img
          src={product.image}
          alt={product.title}
          onError={(e) => { e.currentTarget.style.display = 'none'; }}
        />
        <Overlay className="overlay">
          <Title>{product.title}</Title>
          {clickable && <ExternalIcon />}
        </Overlay>
      </ImageWrap>
    </Card>
  );
}

export default ProductCard;
